<template>
  <v-list dense>
    <template v-for="item in items">
      <div v-if="hasAccess(item.roles)">
      <v-layout
        v-if="item.heading"
        :key="item.heading"
        row
        align-center
      >
        <v-flex xs6>
          <v-subheader v-if="item.heading">
            {{ item.heading }}
          </v-subheader>
        </v-flex>
        <v-flex xs6 class="text-xs-center">
          <a href="#!" class="body-2 black--text">EDIT</a>
        </v-flex>
      </v-layout>
      <v-list-group
        v-else-if="item.children"
        v-model="item.model"
        :key="item.text"
        :prepend-icon="item.model ? item.icon : item['icon-alt']"
        append-icon=""
      >

        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="(child, i) in item.children"
          :key="i"
          @click=""
          :to="child.path"
        >
          <v-list-tile-action v-if="child.icon">
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ child.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <v-list-tile v-else :key="item.text" :to="item.path" @click="">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.text }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      </div>
    </template>
  </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      items: [
        { icon: 'contacts', text: 'บุคคล', path: '/management/persons', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER']},
        { icon: 'school', text: 'เปิดวิชา/กลุ่ม', path: '/management/course/academicYears', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER', 'ROLE_VIEWERS']},
        { icon: 'date_range', text: 'แผนการสอน', path: '/management/course/coursePlan', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { icon: 'person_pin', text: 'วิทยากร', path: '/management/instructors', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { icon: 'wifi', text: 'บัญชีอินเตอร์เนต', path: '/management/internets', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { icon: 'directions_car', text: 'สติ๊กเกอร์จอดรถ', path: '/management/parkings', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { icon: 'comment', text: 'คำร้องนักศึกษา', path: '/management/students', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'โครงการ/สัมมนา',
          model: false,
          roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'],
          children: [
            { icon: 'event_note', text: 'สำนักงาน', path: '/activity/gen', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'event_note', text: 'อบรม/สัมมนา', path: '/activity/nonGen', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'event_note', text: 'งานบริการวิชาการ', path: '/activity/genStaff', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] } 
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'รายงาน',
          model: false,
          roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'],
          children: [
            { icon: 'list_alt', text: 'ข้อมูลบุคคล', path: '/reports/persons', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'ข้อมูลการสอน', path: '/reports/teachingSubjects', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'ข้อมูลแผนการสอน', path: '/reports/coursePlans', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            // { icon: 'list_alt', text: 'วิทยากร', path: '/reports/guests', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'ค่าตอบแทน', path: '/reports/wages', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'ภาระงาน', path: '/reports/workloads', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'สรุปจำนวนนักศึกษา', path: '/reports/aggregateStudents', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'สติ๊กเกอร์จอดรถ', path: '/reports/parkings', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'บัญชีอินเตอร์เนต', path: '/reports/internets', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'คำร้องนักศึกษา', path: '/reports/students', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'โครงการสำนักงาน', path: '/reports/activity/gen', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'อบรม/สัมมนา', path: '/reports/activity/nonGen', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
            { icon: 'list_alt', text: 'งานบริการวิชาการ', path: '/reports/activity/genStaff', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] }
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'ตั้งค่า',
          model: false,
          roles: ['ROLE_ADMIN'],
          children: [
            { text: 'อัตราค่าตอบแทน', path: '/settings/wageRates', roles: ['ROLE_ADMIN'] },
            { text: 'ประเภทบุคคล', path: '/settings/personTypes', roles: ['ROLE_ADMIN'] },
            { text: 'ประเภทโครงการ', path: '/settings/activityTypes', roles: ['ROLE_ADMIN'] },
            { text: 'วิทยาเขต/คณะ/ภาควิชา', path: '/settings/campus', roles: ['ROLE_ADMIN'] },
            { text: 'อาคาร/ห้องเรียน', path: '/settings/buildings', roles: ['ROLE_ADMIN'] },
            { text: 'วิชา', path: '/settings/subjects', roles: ['ROLE_ADMIN'] }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapState(['profile', 'isAuthenticated']),
    ...mapGetters(['token', 'roles', 'username'])
  },
  methods: {
    hasAccess (allowedRoles) {
      if (!allowedRoles || allowedRoles.length === 0) {
        return true
      }
      return this.roles.filter(function (value) {
        return allowedRoles.indexOf(value) > -1
      }).length > 0
    }
  }
    /*methods: {
      logout () {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      }
    }*/
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue